function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import VerticalTimerTabs from "segments/desktop/core-components/vertical-timer-tabs/vertical-timer-tabs";
import classnames from "classnames";
import { StyledTimerVerticalTabsComponent } from "./timer-vertical-tabs-component.scss";
import DefaultProps from "./default-props";
const TimerVerticalTabsComponent = (_param)=>{
    var { isAlignedToCenter, tabsSpace } = _param, rest = _object_without_properties(_param, [
        "isAlignedToCenter",
        "tabsSpace"
    ]);
    return /*#__PURE__*/ _jsx(StyledTimerVerticalTabsComponent, {
        className: classnames("timer-vertical-tabs-component", {
            "center-align": isAlignedToCenter
        }),
        style: {
            "--tab-space": tabsSpace
        },
        children: /*#__PURE__*/ _jsx(VerticalTimerTabs, _object_spread({}, rest))
    });
};
TimerVerticalTabsComponent.defaultProps = DefaultProps;
export default TimerVerticalTabsComponent;
